// Generated by purs version 0.13.8
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_Boolean = require("../Data.Boolean/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_List_Types = require("../Data.List.Types/index.js");
var Data_Map_Internal = require("../Data.Map.Internal/index.js");
var Data_Monoid = require("../Data.Monoid/index.js");
var Data_Newtype = require("../Data.Newtype/index.js");
var Data_Semigroup = require("../Data.Semigroup/index.js");
var Data_Set = require("../Data.Set/index.js");
var Data_Tuple = require("../Data.Tuple/index.js");
var Data_Unit = require("../Data.Unit/index.js");
var Lunarbox_Control_Monad_Dataflow_Solve = require("../Lunarbox.Control.Monad.Dataflow.Solve/index.js");
var Lunarbox_Data_Dataflow_Class_Substituable = require("../Lunarbox.Data.Dataflow.Class.Substituable/index.js");
var Lunarbox_Data_Dataflow_Type = require("../Lunarbox.Data.Dataflow.Type/index.js");
var Lunarbox_Data_Dataflow_TypeError = require("../Lunarbox.Data.Dataflow.TypeError/index.js");
var isRecursive = function (dictSubstituable) {
    return function (subst) {
        return function (t) {
            return Data_Set.member(Lunarbox_Data_Dataflow_Type.ordTVarName)(subst)(Lunarbox_Data_Dataflow_Class_Substituable.ftv(dictSubstituable)(t));
        };
    };
};
var bindVariable = function (a) {
    return function (t) {
        if (Data_Eq.eq(Lunarbox_Data_Dataflow_Type.typeEq)(t)(new Lunarbox_Data_Dataflow_Type.TVariable(false, a)) || Data_Eq.eq(Lunarbox_Data_Dataflow_Type.typeEq)(t)(new Lunarbox_Data_Dataflow_Type.TVariable(true, a))) {
            return Control_Applicative.pure(Lunarbox_Control_Monad_Dataflow_Solve.applicativeSolve)(Data_Monoid.mempty(Lunarbox_Data_Dataflow_Class_Substituable.monoidSubstitution));
        };
        if (isRecursive(Lunarbox_Data_Dataflow_Class_Substituable.typeSubst)(a)(t)) {
            return Lunarbox_Control_Monad_Dataflow_Solve.throwTypeError(Lunarbox_Data_Dataflow_Class_Substituable.monoidSubstitution)(Lunarbox_Data_Dataflow_TypeError.RecursiveType.create(a)(t));
        };
        if (Data_Boolean.otherwise) {
            return Control_Applicative.pure(Lunarbox_Control_Monad_Dataflow_Solve.applicativeSolve)(Lunarbox_Data_Dataflow_Class_Substituable.Substitution(Data_Map_Internal.singleton(a)(t)));
        };
        throw new Error("Failed pattern match at Lunarbox.Control.Monad.Dataflow.Solve.Unify (line 24, column 1 - line 24, column 67): " + [ a.constructor.name, t.constructor.name ]);
    };
};
var unifyMany = function (v) {
    return function (v1) {
        if (v instanceof Data_List_Types.Nil && v1 instanceof Data_List_Types.Nil) {
            return Control_Applicative.pure(Lunarbox_Control_Monad_Dataflow_Solve.applicativeSolve)(Data_Monoid.mempty(Lunarbox_Data_Dataflow_Class_Substituable.monoidSubstitution));
        };
        if (v instanceof Data_List_Types.Cons && v1 instanceof Data_List_Types.Cons) {
            return Control_Bind.bind(Lunarbox_Control_Monad_Dataflow_Solve.bindSolve)(unify(v.value0)(v1.value0))(function (substitution) {
                return Control_Bind.bind(Lunarbox_Control_Monad_Dataflow_Solve.bindSolve)(unifyMany(Lunarbox_Data_Dataflow_Class_Substituable.apply(Lunarbox_Data_Dataflow_Class_Substituable.arrSubst(Lunarbox_Data_Dataflow_Class_Substituable.typeSubst))(substitution)(v.value1))(Lunarbox_Data_Dataflow_Class_Substituable.apply(Lunarbox_Data_Dataflow_Class_Substituable.arrSubst(Lunarbox_Data_Dataflow_Class_Substituable.typeSubst))(substitution)(v1.value1)))(function (substitution$prime) {
                    return Control_Applicative.pure(Lunarbox_Control_Monad_Dataflow_Solve.applicativeSolve)(Data_Semigroup.append(Lunarbox_Data_Dataflow_Class_Substituable.semigroupSubstitution)(substitution$prime)(substitution));
                });
            });
        };
        return Lunarbox_Control_Monad_Dataflow_Solve.throwTypeError(Lunarbox_Data_Dataflow_Class_Substituable.monoidSubstitution)(Lunarbox_Data_Dataflow_TypeError.DifferentLength.create(v)(v1));
    };
};
var unify = function (v) {
    return function (v1) {
        if (Data_Eq.eq(Lunarbox_Data_Dataflow_Type.typeEq)(v)(v1)) {
            return Control_Applicative.pure(Lunarbox_Control_Monad_Dataflow_Solve.applicativeSolve)(Data_Monoid.mempty(Lunarbox_Data_Dataflow_Class_Substituable.monoidSubstitution));
        };
        if (v instanceof Lunarbox_Data_Dataflow_Type.TVariable && (!v.value0 && (v1 instanceof Lunarbox_Data_Dataflow_Type.TVariable && v1.value0))) {
            return bindVariable(v1.value1)(v);
        };
        if (v instanceof Lunarbox_Data_Dataflow_Type.TVariable && (v.value0 && (v1 instanceof Lunarbox_Data_Dataflow_Type.TVariable && !v1.value0))) {
            return bindVariable(v.value1)(v1);
        };
        if (v1 instanceof Lunarbox_Data_Dataflow_Type.TVariable && !v1.value0) {
            return bindVariable(v1.value1)(v);
        };
        if (v instanceof Lunarbox_Data_Dataflow_Type.TVariable) {
            return bindVariable(v.value1)(v1);
        };
        if (v1 instanceof Lunarbox_Data_Dataflow_Type.TVariable) {
            return bindVariable(v1.value1)(v);
        };
        if (v instanceof Lunarbox_Data_Dataflow_Type.TConstant && (v1 instanceof Lunarbox_Data_Dataflow_Type.TConstant && v.value0 === v1.value0)) {
            return unifyMany(Data_Array.toUnfoldable(Data_List_Types.unfoldableList)(v.value1))(Data_Array.toUnfoldable(Data_List_Types.unfoldableList)(v1.value1));
        };
        return Lunarbox_Control_Monad_Dataflow_Solve.throwTypeError(Lunarbox_Data_Dataflow_Class_Substituable.monoidSubstitution)(Lunarbox_Data_Dataflow_TypeError.TypeMissmatch.create(v)(v1));
    };
};
var canUnify = function (type$prime) {
    var $34 = Data_Eq.eq(Data_Eq.eqInt)(0);
    var $35 = Data_Newtype.unwrap(Lunarbox_Control_Monad_Dataflow_Solve.newtypeSolveState);
    var $36 = Lunarbox_Control_Monad_Dataflow_Solve.runSolve({
        location: Data_Unit.unit
    });
    var $37 = unify(type$prime);
    return function ($38) {
        return $34(Data_Array.length((function (v) {
            return v.errors;
        })($35(Data_Tuple.snd($36($37($38)))))));
    };
};
module.exports = {
    unify: unify,
    unifyMany: unifyMany,
    canUnify: canUnify
};
